import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBlobSasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBlobSasQuery = { __typename?: 'Query', afBlobContainerSignature: Array<{ __typename?: 'BlobContainerSignatureOfAfBlobPath', path: Types.AfBlobPath, uri?: string | null, token?: string | null }> };


export const GetBlobSasDocument = gql`
    query GetBlobSas {
  afBlobContainerSignature {
    path
    uri
    token
  }
}
    `;

/**
 * __useGetBlobSasQuery__
 *
 * To run a query within a React component, call `useGetBlobSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlobSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlobSasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlobSasQuery(baseOptions?: Apollo.QueryHookOptions<GetBlobSasQuery, GetBlobSasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlobSasQuery, GetBlobSasQueryVariables>(GetBlobSasDocument, options);
      }
export function useGetBlobSasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlobSasQuery, GetBlobSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlobSasQuery, GetBlobSasQueryVariables>(GetBlobSasDocument, options);
        }
export type GetBlobSasQueryHookResult = ReturnType<typeof useGetBlobSasQuery>;
export type GetBlobSasLazyQueryHookResult = ReturnType<typeof useGetBlobSasLazyQuery>;
export type GetBlobSasQueryResult = Apollo.QueryResult<GetBlobSasQuery, GetBlobSasQueryVariables>;